import { render, staticRenderFns } from "./MainEmergency.vue?vue&type=template&id=599f230e&scoped=true"
import script from "./MainEmergency.vue?vue&type=script&lang=js"
export * from "./MainEmergency.vue?vue&type=script&lang=js"
import style0 from "./MainEmergency.vue?vue&type=style&index=0&id=599f230e&prod&scoped=true&lang=css"
import style1 from "./MainEmergency.vue?vue&type=style&index=1&id=599f230e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599f230e",
  null
  
)

export default component.exports